import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppEnvConfig} from './config.model';

@Injectable({providedIn: 'root'})
export class ConfigService {
	private configData?: AppEnvConfig;

	constructor(private http: HttpClient) {}

	loadAppConfig() {
		return this.http
			.get('/assets/config/config.json')
			.toPromise()
			.then((data: any) => {
				this.configData = data;
			});
	}

	getApiUrl() {
		return this.configData?.root_url;
	}

	getMercureUrl() {
		return this.configData?.mercure_url;
	}

	getDomain() {
		return this.configData?.domain;
	}

	getUrl() {
		return this.configData?.url;
	}

	getIconPath() {
		return this.configData?.icon_path;
	}

	isProduction() {
		return this.configData?.production ?? false;
	}
}
